import { render, staticRenderFns } from "./PostDetailLife.vue?vue&type=template&id=2db01c6a&scoped=true"
import script from "./PostDetailLife.vue?vue&type=script&lang=js"
export * from "./PostDetailLife.vue?vue&type=script&lang=js"
import style0 from "./PostDetailLife.vue?vue&type=style&index=0&id=2db01c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db01c6a",
  null
  
)

export default component.exports